(() => {
  const ROOT_SELECTOR = '[data-cookies-root]';

  const setStatus = (link, text) => {
    const original = link.textContent;
    link.textContent = text;

    window.setTimeout(() => {
      link.textContent = original;
    }, 1800);
  };

  const copySectionLink = async (link) => {
    const url = new URL(link.getAttribute('href'), window.location.href).href;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
        setStatus(link, 'Link skopiowany');
        return;
      }
    } catch (error) {
      console.error('Cookies link copy error:', error);
    }

    window.location.hash = link.getAttribute('href');
  };

  const createPrintDocument = (root) => {
    const clone = root.cloneNode(true);

    clone.querySelectorAll([
      '.pcookies__hero-actions',
      '.pcookies__facts',
      '.pcookies__section-link',
      '.pcookies__crosslink .pcookies__button',
      '.pcookies__footer',
      '[data-cookies-print]'
    ].join(',')).forEach((element) => element.remove());

    clone.querySelectorAll('*').forEach((element) => {
      element.removeAttribute('style');
    });

    const title =
      root.querySelector('h1')?.textContent.trim() ||
      document.title ||
      'Polityka Cookies';

    return {
      title,
      html: clone.outerHTML
    };
  };

  const openPrintView = (root) => {
    const printView = createPrintDocument(root);
    const frame = document.createElement('iframe');

    frame.setAttribute('title', 'Wersja Polityki Cookies do druku');
    frame.setAttribute('aria-hidden', 'true');
    frame.style.position = 'fixed';
    frame.style.left = '-10000px';
    frame.style.top = '0';
    frame.style.width = '1px';
    frame.style.height = '1px';
    frame.style.border = '0';
    frame.style.opacity = '0';
    frame.style.pointerEvents = 'none';

    document.body.appendChild(frame);

    const frameWindow = frame.contentWindow;
    const frameDocument = frame.contentDocument || frameWindow?.document;

    if (!frameWindow || !frameDocument) {
      frame.remove();
      window.print();
      return;
    }

    let cleaned = false;

    const cleanup = () => {
      if (cleaned) return;
      cleaned = true;
      window.setTimeout(() => frame.remove(), 50);
    };

    frameWindow.addEventListener('afterprint', cleanup, { once: true });

    frameDocument.open();
    frameDocument.write(`<!doctype html>
<html lang="pl">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width,initial-scale=1">
  <title>${printView.title.replace(/[<>&"]/g, '')}</title>
  <style>
    @page {
      size: A4;
      margin: 15mm 12mm 16mm;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box;
      color: #111 !important;
      background: #fff !important;
      background-image: none !important;
      box-shadow: none !important;
      text-shadow: none !important;
      filter: none !important;
      -webkit-text-fill-color: #111 !important;
    }

    html,
    body {
      margin: 0;
      padding: 0;
      color: #111 !important;
      background: #fff !important;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 10pt;
      line-height: 1.45;
      -webkit-print-color-adjust: economy;
      print-color-adjust: economy;
    }

    .pcookies,
    .page-width,
    .pcookies__hero-inner,
    .pcookies__layout,
    .pcookies__content {
      width: 100%;
      max-width: none;
      margin: 0;
      padding-left: 0;
      padding-right: 0;
    }

    .pcookies__hero {
      margin: 0 0 6mm;
      padding: 0 0 6mm;
      border-bottom: 1px solid #999;
    }

    .pcookies__hero-inner {
      display: block;
      padding-top: 0;
      padding-bottom: 0;
    }

    .pcookies__eyebrow {
      margin: 0 0 2mm;
      font-size: 8.5pt;
      font-weight: 700;
      letter-spacing: .08em;
      text-transform: uppercase;
    }

    .pcookies h1 {
      margin: 0 0 3mm;
      font-size: 23pt;
      line-height: 1.1;
    }

    .pcookies__lead,
    .pcookies__lead p {
      margin: 0;
      font-size: 10.5pt;
    }

    .pcookies__version-bar {
      display: block;
      margin: 0 0 7mm;
      padding: 0 0 5mm;
      border-bottom: 1px solid #aaa;
    }

    .pcookies__version-bar p {
      margin: 0 0 1.5mm;
      font-size: 9pt;
    }

    .pcookies__toc,
    .pcookies__section {
      margin: 0 0 6mm;
      padding: 5mm;
      border: 1px solid #aaa;
      border-radius: 0;
    }

    .pcookies__toc {
      break-after: page;
      page-break-after: always;
    }

    .pcookies__toc-title {
      margin: 0 0 3mm;
      font-size: 15pt;
    }

    .pcookies__toc ul {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5mm 6mm;
      margin: 0;
      padding-left: 5mm;
    }

    .pcookies__section-tools {
      display: block;
      margin: 0 0 2mm;
    }

    .pcookies__section-number {
      font-size: 8pt;
      font-weight: 700;
      letter-spacing: .08em;
    }

    .pcookies__section h2 {
      margin: 0 0 4mm;
      font-size: 16pt;
      line-height: 1.2;
      break-after: avoid;
      page-break-after: avoid;
    }

    .pcookies__section h3 {
      margin: 5mm 0 2.5mm;
      font-size: 12pt;
      break-after: avoid;
      page-break-after: avoid;
    }

    .pcookies__section p {
      margin: 0 0 3mm;
      orphans: 3;
      widows: 3;
    }

    .pcookies__section ol,
    .pcookies__section ul {
      margin-top: 0;
      padding-left: 7mm;
    }

    .pcookies__section li {
      margin-bottom: 2.6mm;
      orphans: 3;
      widows: 3;
    }

    .pcookies__info-box,
    .pcookies__crosslink {
      margin: 4mm 0;
      padding: 4mm;
      border: 1px solid #999;
      border-radius: 0;
    }

    .pcookies__table-wrap {
      overflow: visible;
      border: 0;
    }

    .pcookies__table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      font-size: 7.4pt;
    }

    .pcookies__table th,
    .pcookies__table td {
      padding: 1.7mm;
      border: 1px solid #999;
      text-align: left;
      vertical-align: top;
      overflow-wrap: anywhere;
    }

    .pcookies__table code {
      font-size: 7pt;
      white-space: normal;
      overflow-wrap: anywhere;
    }

    .pcookies a {
      color: #111 !important;
      text-decoration: underline;
      overflow-wrap: anywhere;
    }

    .pcookies a[href^="http"]::after,
    .pcookies a[href^="/"]::after {
      content: " (" attr(href) ")";
      font-size: 7.5pt;
      font-weight: 400;
      text-decoration: none;
    }
  </style>
</head>
<body>
  ${printView.html}
</body>
</html>`);
    frameDocument.close();

    const triggerPrint = () => {
      try {
        frameWindow.focus();
        frameWindow.print();
      } catch (error) {
        console.error('Cookies print error:', error);
        cleanup();
        window.print();
      }
    };

    if (frameDocument.readyState === 'complete') {
      window.setTimeout(triggerPrint, 250);
    } else {
      frame.addEventListener('load', () => {
        window.setTimeout(triggerPrint, 250);
      }, { once: true });
    }

    window.setTimeout(cleanup, 120000);
  };

  const init = (root) => {
    if (!root || root.dataset.cookiesInitialized === 'true') return;

    root.querySelector('[data-cookies-print]')?.addEventListener('click', () => {
      openPrintView(root);
    });

    root.querySelectorAll('[data-cookies-section-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        copySectionLink(link);
      });
    });

    root.dataset.cookiesInitialized = 'true';
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector(ROOT_SELECTOR));
  });
})();
